import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import { BsEyeFill } from "react-icons/bs";
import { TbEdit } from "react-icons/tb";
import { BsPrinterFill } from "react-icons/bs";
import { PiKeyReturn } from "react-icons/pi";
import { IoMdPrint } from "react-icons/io";
//Srcs
import "../../Style/actionstyle.scss";
import ReturnStudentRent from "./ReturnStudentRent";
import ViewStudentBook from "./ViewStudentBook";
import Delete from "../Include/Delete";
import { DELETE_STUDENT_RENT_MATERIAL } from "../../Schema/StudentRent";
import { AuthContext } from "../../Context/AuthContext";
import UpdateStudentRent from "./UpdateStudentRent";
import PrintRentMaterial from "./PrintRentMaterial";

export default function StudentRentAction({ editData, setRefetch }) {
  //
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  //Modal Return
  const [openPrint, setOpenPrint] = useState(false);
  const handleOpenPrint = () => setOpenPrint(true);
  const handleClosePrint = () => setOpenPrint(false);

  //Modal Return
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal Return
  const [openReturn, setOpenReturn] = useState(false);
  const handleOpenReturn = () => setOpenReturn(true);
  const handleCloseReturn = () => setOpenReturn(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal View
  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseView = () => setOpenView(false);

  //
  const [deleteRentMaterial] = useMutation(DELETE_STUDENT_RENT_MATERIAL, {
    onCompleted: ({ deleteRentMaterial }) => {
      setLoading(false);
      if (deleteRentMaterial?.status === true) {
        setAlert(true, "success", deleteRentMaterial?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteRentMaterial?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteRentMaterial({
      variables: {
        id: editData?._id,
      },
    });
  };

  // console.log("Row::::", editData);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="ព្រីន" placement="top">
          <IconButton onClick={handleOpenPrint}>
            <Box
              className="update-container"
              sx={{ border: "1px solid #4caf50 !important" }}
            >
              <IoMdPrint style={{ fontSize: "18px", color: "#4caf50" }} />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title="ទទួល" placement="top">
          <IconButton onClick={handleOpenReturn}>
            <Box
              className="update-container"
              sx={{ border: "1px solid orange !important" }}
            >
              <PiKeyReturn className="receive-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title="កែប្រែ" placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openPrint && (
        <PrintRentMaterial
          handleClose={handleClosePrint}
          setRefetch={setRefetch}
          editData={editData}
          open={openPrint}
        />
      )}

      {openReturn && (
        <ReturnStudentRent
          handleClose={handleCloseReturn}
          setRefetch={setRefetch}
          editData={editData}
          open={openReturn}
        />
      )}

      {openEdit && (
        <UpdateStudentRent
          handleClose={handleCloseEdit}
          setRefetch={setRefetch}
          editData={editData}
          open={openEdit}
        />
      )}

      {openView && (
        <ViewStudentBook
          open={openView}
          handleClose={handleCloseView}
          editData={editData}
        />
      )}

      {openDel && (
        <Delete
          open={openDel}
          handleClose={handleCloseDel}
          title={"StudentBook"}
          loading={loading}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
}
